<template>
  <section>
    <div v-if="loading">

      <!-- List -->
      <div class="overflow-auto">
      <table class="table table-report -mt-2">
        <thead>
            <tr>
                <th class="whitespace-no-wrap">NOMBRE</th>
                <th class="text-center whitespace-no-wrap"># TAREAS</th>
                  <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
        </thead>
        <tbody>
          <tr class="intro-x" v-for="task in tasks">
              <td>
                  <div class="font-medium whitespace-no-wrap">{{task.user_created_name }}</div>
              </td>
              <td>
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">{{ task.total }}</div>
              </td>
              <td>
                  <div class="text-center text-gray-600 text-xs whitespace-no-wrap cursor-pointer" @click="finishTasks(task.user_created.id)">
                    Finalizar todas
                  </div>
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      <!-- END: List -->

    </div>

    <app-loading v-else />

  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminTaskWithoutFinish',
  data () {
    return {
      loading: false,
      tasks: []
    }
  },
  async beforeMount () {
    try {
      await this.getTasks()
    } catch (error) {} finally {
        this.loading = true
    }
  },
  methods: {
    ...mapActions(['get']),
    async getTasks() {
      const { list } = await this.get(
        `/tasks-without-finish`
      )
      this.tasks = list
    },
    async finishTasks(id) {
      var url = 'finish-tasks-user/'+id
      await this.get(url)
      setTimeout(() => {
      location.reload()
      }, "1000");
    }
  },
  components: {
    appLoading: Loading
  },
}
</script>



// WEBPACK FOOTER //
// TaskWithoutFinish.vue?21991824